import React from "react";
import { HStack } from "@chakra-ui/react";
import { ColorPicker } from "../ColorPicker/ColorPicker";
export const GradientColorPicker = ({ gradientStartId, gradientStartLabel, gradientStartColor, onGradientStartChange, gradientEndId, gradientEndLabel, gradientEndColor, onGradientEndChange, }) => {
    return (React.createElement(HStack, null,
        React.createElement(ColorPicker, { id: gradientStartId, label: gradientStartLabel, color: gradientStartColor, onChange: onGradientStartChange }),
        React.createElement(ColorPicker, { id: gradientEndId, label: gradientEndLabel, color: gradientEndColor, onChange: onGradientEndChange })));
};
